import { useEffect } from 'react';
import styled from 'styled-components';
import { useRefundAccount } from '../Home/Component/RefundAccountFields';

export default function BillRefundAccount({ refreshKey, onEdit }: { refreshKey: number; onEdit: () => void }) {
  const account = useRefundAccount();
  useEffect(() => { if (refreshKey > 0) void account.load(); }, [refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps
  return <Section aria-label="내 환불 계좌">
    <h3>내 환불 계좌</h3>
    {!account.ready && !account.error && <p role="status">환불 계좌를 불러오는 중입니다.</p>}
    {account.error && <><p role="alert">{account.error}</p><button type="button" onClick={() => void account.load()}>다시 조회</button></>}
    {account.ready && (account.value.version ? <>
      <dl><div><dt>은행</dt><dd>{account.value.bank}</dd></div><div><dt>계좌번호</dt><dd>{account.value.account}</dd></div><div><dt>예금주</dt><dd>{account.value.holder}</dd></div></dl>
      <button type="button" onClick={onEdit}>환불 계좌 수정</button>
    </> : <><p>등록된 환불 계좌가 없습니다.</p><button type="button" onClick={onEdit}>환불 계좌 등록하기</button></>)}
  </Section>;
}
const Section = styled.section`
  margin: 24px 0 4px;
  padding: 20px;
  border: 1px solid var(--user-border);
  border-radius: 12px;
  background: var(--user-surface-raised);
  color: var(--user-text);
  min-width: 0;
  h3 { margin: 0; font-size: 16px; font-weight: 700; line-height: 1.5; }
  && p { margin: 8px 0 0; font-size: 14px; line-height: 1.6; color: var(--user-text-muted); }
  dl { margin: 16px 0 0; font-size: 14px; line-height: 1.6; }
  dl div { display: flex; justify-content: space-between; gap: 16px; margin-top: 8px; }
  dt { flex: 0 0 auto; color: var(--user-text-muted); }
  dd { margin: 0; min-width: 0; text-align: right; overflow-wrap: anywhere; font-weight: 600; font-variant-numeric: tabular-nums; user-select: text; }
  button {
    display: block; width: 100%; min-height: 44px; margin-top: 20px; padding: 11px 16px;
    border: 1px solid var(--user-accent); border-radius: 8px;
    background: transparent; color: var(--user-accent); font: inherit; font-size: 14px; font-weight: 600;
    line-height: 1.5; cursor: pointer; touch-action: manipulation;
  }
  button:hover { background: var(--user-accent-soft); }
  button:active { background: var(--user-surface); }
  button:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 3px; }
  && [role="alert"] { color: var(--user-error); }
  @media (max-width: 360px) { padding: 16px; }
`;
